/**
 * SprintSelector Component
 * AIDLC Administrative Backend
 *
 * Dropdown for selecting the active or past sprint for the board view.
 */

import type { Sprint } from '../../../types/projects';

interface SprintSelectorProps {
  sprints: Sprint[];
  selectedSprintId: string | null;
  onSelect: (sprintId: string) => void;
}

function formatDateRange(start: string, end: string): string {
  const s = new Date(start);
  const e = new Date(end);
  const opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  return `${s.toLocaleDateString([], opts)} - ${e.toLocaleDateString([], opts)}`;
}

export function SprintSelector({ sprints, selectedSprintId, onSelect }: SprintSelectorProps) {
  if (sprints.length === 0) {
    return (
      <div className="text-xs text-gray-400 italic">No sprints available</div>
    );
  }

  return (
    <select
      value={selectedSprintId || ''}
      onChange={(e) => onSelect(e.target.value)}
      className="text-xs border border-gray-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-ldaja-blue/50 bg-white min-w-[240px]"
    >
      {sprints.map((sprint) => (
        <option key={sprint.id} value={sprint.id}>
          {sprint.name} ({formatDateRange(sprint.startDate, sprint.endDate)})
          {sprint.status === 'active' ? ' -- Active' : ''}
          {sprint.status === 'completed' ? ' -- Completed' : ''}
        </option>
      ))}
    </select>
  );
}
